export default __webpack_public_path__ + "static/media/bb.d19f7011.svg";